<script>
    import { clickOutside } from "../utils/clickOutside.js";

    export let options = {};

    let showDropdown = false;
</script>

<div
    on:click={() => {
        showDropdown = !showDropdown;
    }}
    use:clickOutside
    on:click-outside={() => {
        showDropdown = false;
    }}
    style={options.style}
    class:active={showDropdown}
>
    <div class="toggle {options.hover ? 'hover' : ''}">
        <slot name="toggle" />
    </div>

    {#if showDropdown}
        <div class="dropdown" style={options.dropdownStyle}>
            <slot />
        </div>
    {/if}
</div>

<style>
    .toggle {
        width: 100%;
    }

    .hover {
        opacity: 0.5;
        cursor: pointer;
    }

    .hover:hover,
    .active {
        opacity: 1;
    }

    .dropdown {
        min-width: 100px;
        background: #f5f5f5;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
        position: absolute;
        z-index: 1;
        border-radius: 5px;
        padding: 10px;
        margin-top: 5px;
        cursor: pointer;
    }

    .dropdown :global(section) {
        padding: 5px;
    }

    .dropdown :global(div) {
        padding: 5px;
    }

    .dropdown :global(div):hover {
        background: #ddd;
    }
</style>
